module.exports = __webpack_public_path__ + "img/the-kingdom-of-gods.188527a3.png";